export class DocDownloadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DocDownloadError';
  }
}
